import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import Personal from './Personal';

function mapStateToProps(state) {
  return {
    meta: metaSelectors.selectMeta(state)
  };
}

export default connect(mapStateToProps, null)(Personal);
